import {useAuthUserStore} from "@/stores/auth";

export default {
    create(academyUuid, data)
    {
        return useAuthUserStore().getApiClient.post('/user/create', data)
    }
}